if (!customElements.get('gallery-slick')) {
    customElements.define(
        'gallery-slick',
        class QuantityPopover extends HTMLElement {
            constructor() {
                super();
                this.itemClick = document.querySelectorAll('[data-role="fotorama-gallery-fancybox-click"]');
                this.btnClose = document.querySelectorAll('[data-role="fotorama-gallery-fancybox-close"]');
                this.sectionGalleryId = document.getElementById(`section-fotorama-${this.dataset.sectionId}`);
                this.galleryApi = null;

                if (this.itemClick) {
                    this.itemClick.forEach((ele) => {
                        ele.addEventListener('click', this.openPopup.bind(this, ele))
                    });
                }

                if (this.btnClose) {
                    this.btnClose.forEach(btn => {
                        btn.addEventListener('click', this.closePopup.bind(this))
                    });
                }
            }

            initSlider() {
                const element = $(`#gallery-slick-${this.dataset.sectionId}`);
                if (this.galleryApi) {
                    element.slick('destroy');
                }
                this.galleryApi = element.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: 0,
                    prevArrow: '<button type="button" class="slick-prev">'
                        + '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" stroke="none" width="15" height="27" viewBox="0 0 15 27">'
                        + '<g fill-rule="evenodd"><path fill-rule="nonzero" d="M14.258 1.53L13.198.47-.061 13.728l13.259 13.258 1.06-1.06L2.061 13.728z"></path></g>'
                        + '</svg></button>',
                    nextArrow: '<button type="button" class="slick-next">'
                        + '<svg fill="currentColor" stroke="none" width="15" height="27" viewBox="0 0 15 27">'
                        + '<g fill-rule="evenodd"><path fill-rule="nonzero" d="M.198 25.926l1.06 1.06 13.259-13.258L1.258.47.198 1.53l12.197 12.198z"></path></g>'
                        + '</svg></button>'
                });

                return this.galleryApi;
            }

            openPopup(e) {
                this.sectionGalleryId.classList.add('open');
                if (!this.galleryApi) {
                    this.initSlider()
                }
                this.galleryApi.slick('slickSetOption', 'speed', 0)
                    .slick('slickGoTo', e.dataset.itemIndex)
                    .slick('slickSetOption', 'speed', 300);
            }

            closePopup() {
                this.sectionGalleryId.classList.remove('open');
            }
        }
    )
}